/**
 * @file
 * @author  fangsimin
 * @date    2020-02-09 21:29:35
 * @last Modified by    fangsimin
 * @last Modified time  2020-02-09 21:33:48
 */
export default {
    'menuData': {
        'contentReview': '内容审核',
        'allReview': '综合审核',
        'userReport': '用户举报',
        'simpleRule': '简单规则'
    }
};



// WEBPACK FOOTER //
// ./src/i18n/langs/msn/cn.js